export const useUserCache = defineStore('userCache', {
  state: () => {
    return {
      userDataCache: new Map<string, UserData>(),
      dedupeCache: new Map<string, any>(),
      allowedPaymentMethodsCache: new Map<string, string[]>(),
      allowedPaymentMethodsRequests: new Map<string, Promise<string[]>>(),
    }
  },
})
